"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForcedPaymentPlanChangeModalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var reactstrap_1 = require("reactstrap");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var ForcedPaymentPlanChangeModalWidget = /** @class */ (function (_super) {
    __extends(ForcedPaymentPlanChangeModalWidget, _super);
    function ForcedPaymentPlanChangeModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.showWordingFlagFieldName = "uistate.shouldShowForceAnnualPaymentWording";
        _this.handleAccept = function () {
            _this.setFlagFieldInInteraction();
            _this.toggle();
        };
        _this.setFlagFieldInInteraction = function () {
            _this.props.onStateChange(_this.showWordingFlagFieldName, false);
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        _this.toggle = function () {
            _this.setState(function (state) { return ({
                isOpen: !state.isOpen
            }); });
            _this.executeEvent("blur");
        };
        _this.state = {
            isOpen: _this.bindFromField(_this.showWordingFlagFieldName)
        };
        return _this;
    }
    ForcedPaymentPlanChangeModalWidget.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.handleAccept });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "info-modal forced-payment-plan-change-modal", id: "forcedPaymentChangeModal", isOpen: this.state.isOpen, toggle: this.toggle, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block mr-3 mb-1", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "Attention icon" }), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium fs-20", children: "Sorry, we can\u2019t offer you a monthly plan" })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { children: "As a result of the change you\u2019ve made to your quote, your payment options have changed. If you\u2019d like to continue to purchase this quote then we can only offer a one off payment." }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)("div", { className: "btn btn-primary btn-next-no-arrow product-button-form btn btn-secondary", id: "forced-payment-plan-understand-btn", role: "button", onClick: this.handleAccept, children: "Ok, I understand" }) })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], ForcedPaymentPlanChangeModalWidget.prototype, "changelogRecorder", void 0);
    return ForcedPaymentPlanChangeModalWidget;
}(plugin_journey_1.WidgetBase));
exports.ForcedPaymentPlanChangeModalWidget = ForcedPaymentPlanChangeModalWidget;
//# sourceMappingURL=ForcedPaymentPlanChangeModalWidget.js.map